"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EffluentSump = void 0;
const EffluentPond_1 = require("./EffluentPond");
const typeName = 'EffluentSump';
class EffluentSump extends EffluentPond_1.EffluentPond {
    constructor(ob) {
        var _a;
        super({ ...ob, type: (_a = ob.type) !== null && _a !== void 0 ? _a : typeName });
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
        };
    }
}
exports.EffluentSump = EffluentSump;
